// eslint-disable-next-line import/prefer-default-export
export const IGNORED_FOCUS_ELEMENTS = ['input', 'textarea'];
